"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Categories = void 0;
let Categories = exports.Categories = /*#__PURE__*/function (Categories) {
  Categories["ACCESSORIES"] = "accessories";
  Categories["BATH_BODY"] = "bath-body";
  Categories["ESSENTIAL_OILS"] = "essential-oils";
  Categories["FRAGRANCE"] = "fragrance";
  Categories["HAIR"] = "hair";
  Categories["KIDS_BABY"] = "kids-baby";
  Categories["MAKEUP"] = "makeup";
  Categories["MEN"] = "men";
  Categories["NUTRITION"] = "nutrition";
  Categories["SKINCARE"] = "skincare";
  Categories["WELLNESS"] = "wellness"; // TODO -- remove wellness replaced by nutrition
  return Categories;
}({});
